import { trackEvent } from "../utils/track-event";
import type {
  CarouselEventBaseProps,
  CarouselEventProps,
  TrackingEvent,
  TrackingEventResponse,
} from "../utils/types";
import { mapCarouselItems } from "../utils/helpers";

type CarouselViewAllSelectedEventProps = CarouselEventBaseProps;

export type CarouselViewAllSelectedEvent = TrackingEvent<
  "Carousel View All Selected",
  Omit<CarouselEventProps, "item" | "visible_items">
>;

export async function trackCarouselViewAllSelectedEvent({
  carouselPosition,
  items,
  contentType,
  shopType,
  title,
  subtitle,
  carouselId,
  imageUrl,
  targetLink,
  targetType,
  responseSourceType,
  resultId,
  gated,
  tab,
}: CarouselViewAllSelectedEventProps): TrackingEventResponse {
  const mappedItems = mapCarouselItems(items);

  return await trackEvent("Carousel View All Selected", {
    props: {
      carousel_content_type: contentType,
      carousel_id: carouselId,
      carousel_position: carouselPosition,
      items: mappedItems,
      num_items: mappedItems.length,
      shop_type: shopType,
      title,
      subtitle,
      image_url: imageUrl,
      target_link: targetLink,
      target_type: targetType,
      response_source_type: responseSourceType,
      result_id: resultId,
      gated,
      tab,
    },
    withRequestSource: true,
  });
}
